module.exports = __webpack_public_path__ + "img/drop_down.3b10d3ea.svg";